import Confirmation from '@/platform/common/components/Confirmation/Confirmation';
import { cn } from '@/platform/lib/utils';
import { useSidebarNavStore } from '@/platform/stores/useSidebarNavStore';
import { Notification } from '@/platform/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ChangeTwoFactorTypeMessage from './components/ChangeTwoFactorTypeMessage/ChangeTwoFactorTypeMessage';
import SidebarNavigation from './components/SidebarNavigation/SidebarNavigation';
import TopNavigation from './components/TopNavigation/TopNavigation';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
            staleTime: 1000 * 60 * 3, // 3 minutes
        },
    },
});

const DashboardLayout = ({ children }) => {
    const { collapsed } = useSidebarNavStore();

    return (
        <QueryClientProvider client={queryClient}>
            <TopNavigation />

            <div className='pt-12'>
                <SidebarNavigation />

                <div
                    className={cn(
                        'transition-all duration-300 ease-in-out',
                        collapsed ? 'lg:pl-0' : 'lg:pl-72'
                    )}
                >
                    <main className='py-10'>{children}</main>

                    <ChangeTwoFactorTypeMessage />
                </div>
            </div>

            <Notification />
            <Confirmation />
        </QueryClientProvider>
    );
};

export default DashboardLayout;
